<template>     
  <v-card flat>      
    <v-card-text v-if="!kelengkapan.status">
      <p>
        Berkas anda belum lengkap. Tombol cetak akan aktif setelah anda melengkapi berkas di bawah ini. 
        <strong>Mohon persyaratan berkas segera dikirim ke Posko PPDB via jasa pengiriman/ diantar langsung. <!--Berkas kami terima paling lambat tgl 19 Feb (pendaftar MA) dan 1 April (pendaftas SD)--></strong>      
      </p>
      <p>
        Alamat pengiriman : <strong>Posko PPDB, Perguruan Islam Ar Risalah<br/>
        Air Dingin RT.01 RW.IX Balai Gadang, Kec Koto Tangah, Padang, Sumatera Barat. Kode pos 25171. Hp: {{$config.cp.label}}
        </strong>
      </p>
      <v-data-table style="width:600px"
        v-bind:headers="kelengkapan.headers"
        v-bind:items="kelengkapan.items"
        hide-actions class="elevation-1 tabular mt-3" 
      >
        <template slot="items" slot-scope="props" >
          <td style="width:10px">{{props.item.id}}</td>
          <td>
              {{props.item.name}}
          </td>                                                                                  
          <td style="width:50px">                                    
            <v-chip color="success" v-if="props.item.status" small dark>lengkap</v-chip>
            <v-chip color="warning" v-else small dark>belum lengkap</v-chip>
          </td>   
        </template>  
      </v-data-table>
    </v-card-text>
    <v-card-actions class="px-3">
      <span v-if="kelengkapan.status">Silahkan cetak kartu ujian anda.</span>
      <span v-else>Info lebih lanjut hubungi admin.</span>
      <v-spacer></v-spacer>
      <v-btn :disabled="!kelengkapan.status" class="blue-grey" large @click="printerPlugin()" :dark="kelengkapan.status"><v-icon> print</v-icon>Print</v-btn>
    </v-card-actions>    
    <v-card-text class="printcontent pb-4" style="height: 550px; margin-top:30px;">      
      <v-layout text-xs-center wrap>        
        <div style="border: 1px solid #aaa; width:350px; margin: auto">
          <v-layout row wrap>
            <div v-if="!kelengkapan.status" style="position:absolute; width:360px; height:100%; z-index:999; background: rgba(0,0,0,0.5)"></div>          
            <v-flex xs12>
              <table>
                <thead>
                  <tr>
                    <th style="width:80px">
                      <img
                        :src="require('@/assets/logo.png')"
                        class="my-3"
                        style="height:50px;"
                      ></img>
                    </th>
                    <th>
                      <h4 style="font-size:12px" class="indigo--text">PERGURUAN ISLAM <span class="green--text">AR RISALAH</span></h4>
                      <h4 style="font-size:12px">PENERIMAAN PESERTA DIDIK BARU (PPDB)</h4>
                      <h3 style="font-size:11px">Seleksi Masuk SD/SMP/MA </h3>
                    </th>
                  </tr>
                </thead>
              </table>
              <hr />
            </v-flex>          
            <v-flex xs12 style="margin-top:0px">
              <h2 style="font-size:14px">Kartu Peserta Ujian</h2>
              <h4 style="font-size:12px">Seleksi Masuk SD/SMP/MA Perguruan Ar Risalah</h4>
              <h4 style="font-size:12px">TAHUN AJARAN 2023/2024</h4>
              <table class="ma-3"  style="font-size:11px">
                <tbody>
                  <tr style="font-size:13px;">
                    <td class="text-xs-left"  style="width:130px"><strong>Nama Peserta Ujian</strong></td><td>:</td><td class="text-xs-left pl-3"><strong>{{fm.nama}}</strong></td>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Nama Orang Tua</td><td>:</td><td class="text-xs-left pl-3">{{fm.ayah_nama}}</td>
                  </tr>
                  <tr>
                    <td class="text-xs-left">Nomor Ujian</td><td>:</td><td class="text-xs-left pl-3">{{fm.calonGedung.number}}</td>
                  </tr>
                  <!--<tr>
                    <td class="text-xs-left">Ruang Ujian</td><td>:</td><td class="text-xs-left pl-3">{{fm.calonGedung.gedung.nama}} - {{fm.calonGedung.ruang.nama}}</td>
                  </tr> 
                  <tr>
                    <td class="text-xs-left">Jadwal Ujian</td><td>:</td><td class="text-xs-left pl-3">{{getJadwalUjian(fm.tingkat_id)}}</td>
                  </tr>--> 
                </tbody>
              </table>
              <!--<v-layout row wrap class="mx-2 my-5" style="font-size:11px; margin-top:-15px">
                <v-flex xs1  class="text-xs-right">NB</v-flex>
                <v-flex xs11 class="text-xs-left">
                  <ol>
                    <li>Kartu ujian dibawa saat ujian tulis</li>
                    <li>Membawa alat tulis dan papan ABO</li>
                    <li>Memakai seragam sekolah masing-masing</li>
                  </ol>
                </v-flex>
              </v-layout>-->
              <v-layout row wrap class="mx-4">
                <!--<v-flex xs4 class="text-xs-left">
                  <div style="width:100px; height:100px; border:1px solid #eee; position: relative" class="text-xs-center">
                    <img v-if="imgUrl" :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')" style="max-width:100%; max-height:150px;" />
                    <span  @click="cropshow=true" v-else class="my-4">Pas Foto</span>                               
                  </div>
                </v-flex>-->
                <!--<v-flex xs8 class="text-xs-left pl-4 mb-3" style="position:relative">
                  <h4 class="text-xs-left" style="font-size:11px;">Padang, {{$moment().format('DD MMMM YYYY')}}</h4>
                  <h4 class="text-xs-left" style="font-size:11px;">Panitia PPDB</h4>
                  <h4 class="text-xs-left" style="font-size:11px;">Ketua</h4>
                  <img src="@/assets/img/ttddonis.png" style="height:62px; top:40px; position: absolute" />
                  <h3 class="text-xs-left" style="margin-top: 30px;font-size:11px;"><u>H. Donis Satria Lc.MA</u></h3>
                  <span class="text-xs-left" style="font-size:11px;">NIK : 2005.01.1980.08.20.010</span>
                </v-flex>-->
              </v-layout>            
            </v-flex>
          </v-layout>        
        </div>              
      </v-layout>          
    </v-card-text> 
    <crop-upload style="width:100%;" field="img"
      @crop-success="cropSuccess"        
        :width="300"
        :height="300"         
        lang-type="en"
        :value.sync="cropshow"
        v-model="cropshow"                
        img-format="png">            
    </crop-upload>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="!conti && fm.status < 4" class="pa-1" @click="stepkeLocal = 6">Continue</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Model from '@/models/dashboard';
import User  from '@/util/models/User';
import CropUpload from 'vue-image-crop-upload';
const  model = new Model();

export default {
  name:'step4',  
  components:{CropUpload},
  props:{
    stepke:{
      type: Number,
      default: null,
    },
  },
  watch:{
    stepke(newStep){this.stepkeLocal = newStep},
    stepkeLocal(newStep){this.$emit('update:stepke', newStep);this.getavatar();}
  },
  data:()=>({  
    cropshow: false,
    stepkeLocal : null,
    conti : false,
    user : User.attributes(),
    imgLoading : false,
    imgUrl : null,
    fm : {
      user : {
          username : null,
          phone : null,
          password : null,
          status : 10,
      },
      user_id : null,
      tingkat_id : null,
      jurusan_id : null,
      nama : null,
      gender : null,
      lahir_tempat : null,
      lahir_tanggal : null,
      lahir_tanggalV : null,
      alamat : null,
      kelurahan_id : null,
      kecamatan_id : null,
      kota_id : null,
      provinsi_id : null,
      prestasi_osn : null,
      prestasi_mtq : null,
      prestasi_hafidz : null,
      prestasi_other : null,
      sekolah_nama : null,
      sekolah_provinsi_id : null,
      sekolah_kota_id : null,
      telepon : null,
      whatsapp : null,
      email : null,
      ayah_nama : null,
      ayah_pekerjaan : null, 
      ayah_jabatan : null,
      ayah_penghasilan : null,
      ibu_nama : null,
      ibu_pekerjaan : null, 
      ibu_jabatan : null,
      ibu_penghasilan : null,
      calonPrestasis : [],
      calonGedung : {
        gedung : {},
        ruang : {}
      },      
    },
    kelengkapan : {
      status : false,
      items  : [],
      headers : [
        {text:'No', value:'id'},
        {text:'Berkas', value:'name'},
        {text:'Status', value:'status'},
      ]
    }
  }),
  mounted(){
    this.init(); this.getavatar();
  },
  methods:{
    init(){
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        Object.assign(this.fm, data);                
      });  
      
      model.kelengkapans().then(res => {
        this.kelengkapan.status = res.status;
        this.kelengkapan.items  = res.data;
      });
    },
    
    printerPlugin(){
      this.conti = true;
      model.setCetak();
      print();
    }, 
    
    getJadwalUjian(tingkat){
      switch(tingkat){case 2:return 'Sabtu, 4 Januari 2020, 07:00 WIB'; break; case 3:return 'Ahad, 23 Februari 2020, 07:00 WIB'; break; default:return 'none'; break;}
    },
        
    cropSuccess(imgDataUrl, field){
      //console.log('-------- crop success --------');
      //this.imgDataUrl = imgDataUrl;

      var block = imgDataUrl.split(";");
      var contentType = block[0].split(":")[1];// In this case "image/gif"
      var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      var blob = this.b64toBlob(realData, contentType);

      var FormData = require('form-data');
      let formData = new FormData();

      formData.append('image', blob, 'userprofile');
      formData.append('reff_id', this.user.id);
      formData.append('reff_type', 1);        

      this.imgLoading = true;
      model.setavatar(formData).then(res=>{
        this.getavatar();            
      });
    }, 
    
    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.user.id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },

  }
};
</script>
<style>
.printcontent * {visibility: visible; color:#000;}  
.printcontent {position : relative; top:0px; left:0px; z-index: 0}  
@media print
{
    body * {visibility:hidden;}
    .printcontent * {visibility : visible;}
    .printcontent {position : fixed; top:0px; left:0px;}
}
</style> 

